export default __webpack_public_path__ + "static/media/coupon.37436f0b.svg";